export default __webpack_public_path__ + "static/media/28_gallery.4e741dfb.jpg";